import { TmcContextService } from './../../../common/tmc-context.service';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { Inject, ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DialogService, TranslationService } from '@sdbn/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ResponseMessage } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { EditTransportService } from '../service/edit-transport.service';
import { AppClientConfigurationService } from '@sdbn/common';
import { EditableTransportOption } from '../../transport-options-editor/transport-option-editor.model';
import { TransportOption, TransportOptionColumn, TransportOptionParameter, TransportOptionParameterValue, TransportOptionSelection, TransportOptionsPanelModel } from '../../transport-options-panel/transport-options-panel.model';
import { Subscription } from 'rxjs';
import { YardConfiguration } from '../../../client/model/yard-configuration';
import { TransportDetailLayout, TransportDetailMode } from '../../../common/configuration/transport.configuration';
import { TransportManagementLevel } from '../../../common/model/transport.model';
import { EditTransport } from '../edit-transport.model';
import { TransportDetailsLayoutConverter } from '../../../common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailsLayoutService } from '../../transport-details/transport-details-layout.service';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';


@Component({
    templateUrl: './edit-transport.component.html',
    styleUrls: ['./edit-transport.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditTransportComponent implements OnInit {

  TransportDetailMode = TransportDetailMode;
  TransportManagementLevel = TransportManagementLevel;

  editTransport: EditTransport;
  layout: TransportDetailLayout;

  formGroup = new FormGroup({
    registerArrival: new FormControl(null, []),
    registerEntrance: new FormControl(null, [])
  });

  model: TransportOptionsPanelModel;
  validStateSubscription: Subscription;
  selectionChangeSubscription: Subscription;

  tmcContextSubscription: Subscription;
  yardConfiguration: YardConfiguration;

  selectedOptions = new Array<EditableTransportOption>();

  transportDetailsValid = false;
  lastEntranceChoice = false;
  isLoading = false;
  changing: boolean = false;

  responseMessages: ResponseMessage[];

  constructor(
    public dialogRef: MatDialogRef<EditTransportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private editTransportService: EditTransportService,
    public cps: AppClientConfigurationService,
    private dialog: MatDialog,
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
    private dialogService: DialogService,
    layoutConverter: TransportDetailsLayoutConverter
  ) {

    this.layout = layoutConverter.convert(this.transportDetailsLayoutService.createEditTransportMasterdataLayout());
    this.lastEntranceChoice = cps.isPropertyTrue(TMCClientParameters.P_VISITOVERVIEW_REGISTER_REGISTER_ENTRANCE_VALUE, false);

    this.formGroup.valueChanges.subscribe(value => {
      if (!this.changing) {
        this.changing = true;
        const registerNowChanged = this.editTransport.registerNow !== value.registerArrival;
        this.editTransport.registerNow = value.registerArrival;
        if (registerNowChanged) {
          if (value.registerArrival) {
            this.formGroup.controls['registerEntrance'].setValue(this.lastEntranceChoice, { emitEvent: false, onlySelf: true });
            this.formGroup.controls['registerEntrance'].enable({ emitEvent: false, onlySelf: true });
          } else {
            this.formGroup.controls['registerEntrance'].setValue(false, { emitEvent: false, onlySelf: true });
            this.formGroup.controls['registerEntrance'].disable({ emitEvent: false, onlySelf: true });
          }
        } else {
          this.lastEntranceChoice = value.registerEntrance;
        }
        this.changing = false;
      }
    });
  }

  ngOnInit() {

    this.isLoading = true;
    this.editTransportService.getTransport({ id: this.data.transportId }).subscribe(response => {
      this.isLoading = false;
      this.editTransport = new EditTransport(response);

      const selectedOptions = new Array<EditableTransportOption>();
      for (const po of this.editTransport.selectedOptions) {
        selectedOptions.push(new EditableTransportOption(po));
      }
      this.selectedOptions = selectedOptions;

      this.createTransportOptionsModel();

      this.changing = true;
      this.formGroup.patchValue({
        registerArrival: false,
        registerEntrance: false
      });
      this.changing = false;

    }, error => {
      console.log(error);
      this.isLoading = false;
    });
  }

  createTransportOptionsModel() {

    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
    }

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(yardConfiguration => {
      if (yardConfiguration != null) {
        this.yardConfiguration = yardConfiguration;

        let columns = this.createOptionsFromConfiguration();

        const selection = this.editTransport.selectedOptions;

        this.model = new TransportOptionsPanelModel({ columns: columns, constraints: this.yardConfiguration.transportOptionConstraints, selection: selection, loadingEnabled: true, parametersEnabled: true });
        this.validStateSubscription = this.model.validState.subscribe(bool => {
          this.transportDetailsValid = bool;
        });

        this.selectionChangeSubscription = this.model.selectionChange.subscribe(value => {

          this.editTransport.optionsChanged = true;
          this.editTransport.selectedOptions = this.model.getOnlySelectedTransportOptionSelection();
        });
      }
    });
  }

  private createOptionsFromConfiguration(): Array<TransportOptionColumn> {
    let columns = new Array<TransportOptionColumn>();
    for (let option of this.yardConfiguration.transportOptions) {
      while (option.columnIndex != null && columns.length < option.columnIndex + 1) {
        let column = new TransportOptionColumn();
        columns.push(column);
      }
      let column = columns[option.columnIndex];
      column.options.push(new TransportOption(option));
    }
    return columns;
  }

  isSaveDisabled() {
    if (this.isLoading) {
      return true;
    }

    if (!this.model.valid) {
      return true;
    }

    return !this.transportDetailsValid;
  }

  save() {
    this.isLoading = true;

    if (this.editTransport.transport.masterdata.managementLevel === TransportManagementLevel.LOCATION && this.editTransport.optionsChanged && this.editTransport.updateRoutingPossible) {

      this.dialogService.showConfirm(
        'tmc-yard.common.transport-routing.reload-route.confirm-dialog.title',
        'tmc-yard.common.transport-routing.reload-route.confirm-dialog.message'
      ).afterClosed().subscribe(result => {
        if (result) {
          this.editTransport.updateRouting = true;
          this.saveAndClose();
        } else {
          this.saveAndClose();
        }
      });
    } else {
      this.saveAndClose();
    }
  }

  private saveAndClose() {
    this.editTransportService.save(new EditTransport(this.editTransport)).subscribe(response => {

      this.isLoading = false;
      this.responseMessages = response.responseMessages;

      if (response.status === ResponseStatus.SUCCESS) {
        if (this.editTransport.inPlanningMode && this.formGroup.value.registerEntrance) {
          this.dialogRef.close({ action: 'registerTransport', transportId: this.data.transportId });
        } else {
          this.dialogRef.close();
        }
      }
    }, error => {
      console.log(error);
      this.isLoading = false;
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  isFormReadonly() {
    return this.isLoading;
  }

  swapTrailerEnabled() {
    return this.cps.isPropertyTrue(TMCClientParameters.P_VISITS_ATTACH_DETACH_ENABLED, false) &&
      this.cps.isPropertyTrue(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }

  public onValidChanged(valid: boolean) {
    this.transportDetailsValid = valid;
  }



}
